import { checkExpToken, checkKey, checkWeirdBadKey } from "helpers/auth";
import { log, warn, error } from "utils/logger";

export const getPolicy = async (policyId, isRenewal) => {
	let policy = {};
	const endpoint = `getPolicy`;
	const payload = {
		params: {
			policyID: policyId,
			isRenewal: isRenewal,
		},
	};
	const reqType = "get";

	policy = await checkKey({ endpoint, payload, reqType });

	return policy;
};

export const getPolicyRisks = async (policyId, isRenewal) => {
	let risks = {};

	const endpoint = `/getPolicyRisks`;
	const reqType = "get";
	const payload = {
		params: {
			policyID: policyId,
			isRenewal: isRenewal,
		},
	};

	risks = await checkKey({ endpoint, payload, reqType });

	return risks;
};

export const getPolicyExtensions = async policyId => {
	let extensions = {};
	const endpoint = `/getPolicyExtensions`;
	const payload = {
		params: {
			policyID: policyId,
		},
	};
	const reqType = "get";

	extensions = await checkKey({ endpoint, payload, reqType });
	// let policy_id = encodeURIComponent(policyId)
	// await dNet.get(`/getPolicyExtensions?token=${token}&policyID=${policy_id}`).then(res => {
	//     extensions = res.data
	// })
	return extensions;
};

export const getPolicyProfExt = async policyPrefix => {
	let extensions = {};

	const endpoint = `/getPolicyProfExt`;
	const payload = {
		params: {
			policyPrefix: policyPrefix,
		},
	};
	const reqType = "get";

	extensions = checkKey({ endpoint, payload, reqType });

	return extensions;
};

export const checkPromoCode = async code => {
	const endpoint = `/checkPromoCode`;
	const payload = {
		params: {
			ratingCode: code,
		},
	};
	const reqType = "post";

	let ratingCode = checkKey({ endpoint, payload: null, reqType }, payload);

	return ratingCode;
};

export const getPolicyByParams = async params => {
	const endpoint = `/getPolicyByParams`;
	const reqType = "get";
	let policy = {};
	let payload = params.policy_number === null || params.policy_number === undefined || params.policy_number === ''? {
		params: {
			
			regNo: params.regNo,
			trn: params.trn
		}
	}   :
		{
			params: {
			policyNo: params.policy_number,
				regNo: params.regNo,}
			};
	policy = checkKey({ endpoint, payload, reqType });
	return policy;
};

export const getPolicyProfRatingCodes = async policyPrefix => {
	let extensions = {};

	const endpoint = `/getRatingCodes`;
	const payload = {
		params: {
			policyPrefix: policyPrefix,
		},
	};
	const reqType = "get";

	extensions = checkKey({ endpoint, payload, reqType });

	return extensions;
};

export const getExchangeRate = async (from, to, effective_date, country) => {
	let rate = {};

	const endpoint = `/getExchangeRate`;
	const payload = {
		params: {
			from: from,
			to: to,
			date: effective_date,
			country: country,
		},
	};

	const reqType = `get`;

	rate = checkKey({ endpoint, payload, reqType });

	return rate;
};

export const getPaymentPlans = async (currency, effectiveDate, policyPrefix) => {
	let paymentPlans = {};
	const endpoint = `/getPaymentPlans`;

	const payload = {
		params: {
			currency: currency,
			effective_date: effectiveDate,
			prefix: policyPrefix,
		},
	};

	const reqType = "get";

	paymentPlans = await checkKey({ endpoint, payload, reqType });

	return paymentPlans;
};

export const getQuotePaymentPlans = async quoteDetails => {
	log("getQuotePaymentPlans called with:", quoteDetails);
	const currentDate = new Date();
	const day = String(currentDate.getDate()).padStart(2, "0");
	const month = String(currentDate.getMonth() + 1).padStart(2, "0");
	const year = currentDate.getFullYear();
	const effectiveDate = `${month}/${day}/${year}`;
	const currency = "JA";
	const paymentPlansEndpoint = `/getPaymentPlans`;

	try {
		const getPlansPayload = {
			params: {
				prefix: quoteDetails.policyPrefix,
				effective_date: effectiveDate,
				currency: currency,
			},
		};
		log("Calling checkKey for getPaymentPlans with payload:", getPlansPayload);
		const plansResponse = await checkKey({ endpoint: paymentPlansEndpoint, payload: getPlansPayload, reqType: "get" });
		log("Response from checkKey (getPaymentPlans):", plansResponse);

		let planIds = [];
		if (plansResponse && Array.isArray(plansResponse.payment_plans)) {
			planIds = plansResponse.payment_plans.map(plan => plan.id);
		} else {
			warn("No valid payment_plans array found in getPaymentPlans response object:", plansResponse);
		}

		if (planIds.length === 0) {
			log("No payment plan IDs returned. Mapping response with only full payment.");
			const fullPaymentOnly = mapToPaymentPlanResponse(quoteDetails, []);
			return fullPaymentOnly;
		}
		log("Available Plan IDs:", planIds);

		const getQuotationPlansEndpoint = "/GetQuotationPaymentPlan";
		const getQuotationPlansPayload = {
			params: {
				quotation_id: quoteDetails.encryptedQuoteId,
				alternate_payment_plans: planIds.join(","),
			},
		};
		log("Calling checkKey for GetQuotationPaymentPlan with payload:", getQuotationPlansPayload);
		const quotationPlansResponse = await checkKey({
			endpoint: getQuotationPlansEndpoint,
			payload: getQuotationPlansPayload,
			reqType: "get",
		});
		log("Response from checkKey (GetQuotationPaymentPlan):", quotationPlansResponse);

		let calculatedPlans = [];
		if (quotationPlansResponse && Array.isArray(quotationPlansResponse.calculated_payment_plans)) {
			calculatedPlans = quotationPlansResponse.calculated_payment_plans;
			log("Calculated Plans Received:", calculatedPlans.length);
		} else {
			error(
				"Invalid or missing calculated_payment_plans structure in response object:",
				quotationPlansResponse
			);
		}

		const filteredPlans = calculatedPlans.filter(plan =>
			plan.payment_terms.every(term => term.payment_term_premium > 7500)
		);
		log("Filtered Plans (premium > 7500):", filteredPlans.length);

		const finalOptions = mapToPaymentPlanResponse(quoteDetails, filteredPlans);
		log("Final mapped options:", finalOptions);
		return finalOptions;
	} catch (err) {
		// Log the specific error encountered during the process
		error("Error inside getQuotePaymentPlans:", err);
	}
};

// Ensure mapToPaymentPlanResponse uses the correct field (e.g., annualPrice)
function mapToPaymentPlanResponse(quoteDetails, filteredEpicPlans) {
	log("quoteDetails", quoteDetails);
	const options = filteredEpicPlans
		.map(plan => {
			const firstPaymentTerm = plan.payment_terms.find(t => t.payment_number === 1);
			const subsequentPaymentTerm = plan.payment_terms.find(t => t.payment_number > 1);
			const payNow = firstPaymentTerm?.payment_term_premium_with_tax ?? 0;
			const payMonthly = subsequentPaymentTerm?.payment_term_premium_with_tax ?? 0;
			const payNowWithStampDuty = payNow > 0 ? payNow + 200 : 0;

			return {
				paymentPlanId: plan.payment_plan_id,
				numberParts: plan.payment_terms.length,
				name: plan.payment_plan_name,
				effective_date: plan.effective_date,
				expiry_date: plan.expiry_date,
				payNow: payNow,
				payNowWithStampDuty: payNowWithStampDuty,
				payMonthly: payMonthly,
				balances: plan.payment_terms.map(term => ({
					paymentNumber: term.payment_number,
					balance: term.payment_term_premium_with_tax,
					effectiveDate: term.effective_date,
					expiryDate: term.expiry_date,
					title: term.title_for_certificate,
				})),
				total: payNowWithStampDuty,
				second_premium_payment: payMonthly,
				payment_terms: plan.payment_terms.map(term => ({
					payment_term_premium_with_tax: term.payment_term_premium_with_tax,
					effective_date: term.effective_date,
					expiry_date: term.expiry_date,
				})),
				isQbPlan: true,
			};
		})
		.sort((a, b) => a.numberParts - b.numberParts);

	const fullPaymentAmount = quoteDetails.grossTotal || quoteDetails.annualPrice;

	return {
		quoteResultId: quoteDetails.quoteId,
		QuoteId: quoteDetails.quoteId,
		PolicyHolderFirstname: quoteDetails.policyHolderFirstName,
		fullPaymentNow: fullPaymentAmount ?? 0,
		Options: options,
	};
}

export const getTransactionSchedule = async transactionId => {
	let schedule = {};
	let endpoint = `/getTransactionSchedule`;
	let payload = {
		transaction_id: transactionId,
	};

	schedule = await checkKey({ endpoint, payload });

	return schedule;
};

export const getPolicyTransactions = async policyId => {
	let transactions = {};
	let endpoint = `/getPolicyTransactions`;
	const payload = {
		policy_id: policyId,
	};
	transactions = await checkKey({ endpoint, payload });
	return transactions;
};

export const getPolicyFiles = async policyId => {
	let files = {};
	let endpoint = `/getPolicyFiles`;
	const payload = {
		policy_id: policyId,
	};
	files = await checkKey({ endpoint, payload });
	return files;
};

/**
 
 * @param {{ auto_authorize: boolean; branch: string; receipt_date: string; policy_id: any; amount: number; payment_type: string; currency: string; is_tax_exempt: boolean; }[]} receiptArray
 */
export const drawReceiptBatch = async receiptArray => {
	let payload = {
		receiptArray,
	};

	let endpoint = `/drawReceiptBatch`;

	return await checkWeirdBadKey({ endpoint, payload });
};

/**
 
 * @param {{ auto_authorize: boolean; branch: string; receipt_date: string; policy_id: any; client_global_name_id: string; amount: number; payment_type: string; manual_receipt_number: string; currency: string; is_tax_exempt: boolean; }[]} receiptArray
 */
export const drawReceipt = async receipt => {
	let payload = {
		...receipt,
	};

	let endpoint = `/drawReceipt`;

	return await checkKey({ endpoint, payload });
};

export const getPolicyPaymentPlan = async policyId => {
	let pPaymentPlan = {};

	const endpoint = `/getPolicyPaymentPlan`;
	const payload = {
		params: {
			policy_id: policyId,
		},
	};
	const reqType = `get`;

	pPaymentPlan = checkKey({ endpoint, payload, reqType });

	return pPaymentPlan;
};

export const getStreetTypes = async () => {
	let response = {};

	const endpoint = "/getStreetTypes";
	const payload = {
		params: {},
	};

	const reqType = `get`;
	response = await checkKey({ endpoint, payload, reqType });
	return response;
};

export const getParishTowns = async param => {
	let response = {};
	const endpoint = "/getParishTowns";
	const payload = {
		params: {
			param: param,
		},
	};
	const reqType = `get`;
	response = await checkKey({ endpoint, payload, reqType });
	return response;
};

export const getGeneralAreas = async param => {
	let response = {};
	const endpoint = "/getGeneralAreas";
	const payload = {
		params: {
			param: param,
		},
	};
	const reqType = `get`;
	response = await checkKey({ endpoint, payload, reqType });
	return response;
};

export const genPolicyModification = async payload => {
	let response = {};
	const endpoint = `/policyModification`;

	try {
		response = await checkKey({ endpoint, payload });

		// Response comes directly from API, not wrapped in .data
		if (!response.success) {
			return {
				success: false,
				message: response.message || "An error occurred Cannot update policy",
				...response
			}
		}
		return response;
	} catch (error) {
		error("Error in genPolicyModification:", error);
		return {
			success: false,
			message: "An unexpected error occurred while updating the policy.",
			error: error.response?.data?.message || error.message
		};
	}

};

export const modifyPolicyVehicles = async ({ 
	policyId, 
	effective_date,
	only_calculate_premium = false, 
	transaction_premium = 0,
	new_risk,
	globalNames = [],
}) => { 
	let response = {};
	const endpoint = `/policyModification`;


	const payload = { 
		policy_id: policyId,
		authorize_transaction: true,
		effective_date: effective_date,
		only_calculate_premium: only_calculate_premium,
		is_do_not_prorate: false,
		action: "change_of_vehicle",
		/* trans_wordings: {
			delete_vehicle_wording: "",
			add_vehicle_wording: "Adding vehicle(s) - CORE-U.",
		}, */
		trans_wording: "Adding vehicle(s) - CORE-U.",
		transaction_premium: transaction_premium,
		service_charge_type: "change_of_vehicle",
		service_charge_value: 2000,
		parameters: { 
			global_names: globalNames,
			new_risk: new_risk
		},
	};
	response = await checkKey({ endpoint, payload });
	return response;
};


export const addRiskToPolicy = async ({ 
	policyId, 
	effective_date,
	risk,
	globalNames = [],
	trans_wording = "Adding vehicle(s) - CORE-U.",
	only_calculate_premium = false,
	transaction_premium = 0,
}) => { 
	let response = {};
	const endpoint = `/policyModification`;

	const payload = { 
		policy_id: policyId,
		effective_date: effective_date,
		only_calculate_premium: only_calculate_premium,
		is_do_not_prorate: false,
		authorize_transaction: true,
		create_certificate: false,
		create_cover_note : false,
		action: "add_risk",

		trans_wordings: {
			trans_wording: trans_wording
		},
		transaction_premium: transaction_premium,
		parameters: {
			global_names: globalNames,
			risk: risk
		},
		is_tax_exempt: false,
		service_charge_type : "Policy Changes",
		service_charge_value : 2500
	};
	response = await checkKey({ endpoint, payload });
	return response;
};
export const deleteRiskFromPolicy = async ({ 
	policyId, 
	effective_date,
	only_calculate_premium = false,
	service_charge_value = 2500,
	service_charge_type = "Policy Changes",
	transaction_premium = 0,
	risk,
	globalNames = [],
	trans_wording = "Deleting a vehicle - CORE- U.",
}) => { 
	let response = {};
	const endpoint = `/policyModification`;

	const payload = { 
		policy_id: policyId,
		effective_date: effective_date,
		only_calculate_premium: only_calculate_premium,
		is_do_not_prorate: false,
		authorize_transaction: true,
		action: "delete_risk",
		trans_wordings: {
			trans_wording: trans_wording
		},
		transaction_premium: transaction_premium,
		parameters: {
			risk_id: risk.risk_id,
            chassis_number: risk.chassis_number,
			risk_item_type: risk.risk_item_type
		},
		is_tax_exempt: false,
		//service_charge_type : service_charge_type,
		//service_charge_value : service_charge_value
		
	};
	response = await checkKey({ endpoint, payload });
	return response;
};

export const changeRiskOnPolicy = async ({ 
	policyId, 
	effective_date,
	only_calculate_premium = false,
	transaction_premium = 0,
	risk,
	globalNames = [],
	trans_wording = "Adding vehicle(s) - CORE-U.",
	oldRiskId = null,
	policy
}) => { 
	let response = {};
	const endpoint = `/policyModification`;

	const payload = { 
		policy_id: policyId,
		effective_date: effective_date,
		only_calculate_premium: only_calculate_premium,
		is_do_not_prorate: false,
		authorize_transaction: true,
		create_certificate: false,
		create_cover_note: false,
		action: "change_of_vehicle",
		trans_wordings: {
			delete_vehicle_wording: "Deleting a vehicle - CORE- U.",
			add_vehicle_wording: trans_wording
		},
		transaction_premium: transaction_premium,
		parameters: {
			global_names: globalNames,
			old_risk_id: oldRiskId || policy.risks[0].risk_id,
			new_risk: risk
		},
		is_tax_exempt: false,
		service_charge_type : "Policy Changes",
		service_charge_value : 2500
	};
	response = await checkKey({ endpoint, payload });
	return response;
};

export const policyModification = async (policyId, effective_date, end_date, risk_increase_sum_insured, risk_id) => {
	let modifications = {};

	const endpoint = `/policyModification`;
	const payload = {
		params: {
			policy_id: policyId,
			effective_date: effective_date,
			end_date: end_date,
			risk_increase_sum_insured: risk_increase_sum_insured,
			risk_id: risk_id,
		},
	};
	modifications = checkKey({ endpoint, payload });

	return modifications;
};

export const getSingleReceipt = async (include_pdf, receipt_id) => { 
	let payload = { 
		include_pdf,
		receipt_id,
	};

	let endpoint = `/getSingleReceipt`;

	return await checkKey({ endpoint, payload });
}

/**
 *
 * @param {Object} args
 * @param {string} args.policyId
 * @param {string} args.effective_date
 * @param {string} args.end_date
 * @param {string} args.action
 * @param {string} args.trans_wording
 * @param {string} args.risk_id
 * @param {string} args.sum_insured
 * @param {boolean} args.is_do_not_prorate
 * @returns
 */
export const updatRiskSumInsured = async ({
	policyId,
	effective_date,
	end_date,
	action,
	trans_wording,
	risk_id,
	sum_insured,
	is_do_not_prorate,
}) => {
	let modifications = {};

	const endpoint = `/policyModification`;
	const payload = {
		authorize_transaction: true,
		policy_id: policyId,
		effective_date: effective_date,
		end_date: end_date,
		is_do_not_prorate,
		action: action,
		trans_wordings: {
			trans_wording: trans_wording,
		},
		transaction_premium: 0,
		parameters: {
			risk_id: risk_id,
			sum_insured: sum_insured,
		},
		external_reference_number: "",
		is_tax_exempt: false,
		service_charge_type: "",
		service_charge_value: 0,
	};
	modifications = checkKey({ endpoint, payload });

	return modifications;
};

export const getNewCalculatedPremium = async ({
	policyId,
	effective_date,
	end_date,
	action,
	trans_wording,
	risk_id,
	sum_insured,
}) => {
	let modifications = {};
	const endpoint = `/policyModification`;
	const payload = {
		authorize_transaction: true,
		policy_id: policyId,
		effective_date: effective_date,
		end_date: end_date,
		is_do_not_prorate: false,
		action: action,
		trans_wordings: {
			trans_wording: trans_wording,
		},
		transaction_premium: 0,
		parameters: {
			risk_id: risk_id,
			sum_insured: sum_insured,
		},
		external_reference_number: "",
		is_tax_exempt: false,
		service_charge_type: "",
		service_charge_value: 0,
		only_calculate_premium: true,
	};
	modifications = checkKey({ endpoint, payload });

	return modifications;
};

export const createPolicy = async payload => {
	let response = {};
	const endpoint = `createPolicy`;

	response = await checkKey({ endpoint, payload });
	return response;
};

/**
 *
 * @param {Object} args
 * @param {string} args.policy_id
 * @param {string=} args.narratives_to_add
 * @param {string=} args.narratives_to_remove
 * @returns
 */
export const updatePolicyNarratives = async ({ policy_id, narratives_to_add, narratives_to_remove }) => {
	let endpoint = "/updatePolicyNarratives";

	let response = await checkKey({
		endpoint,

		payload: {
			policy_id,
			narratives_to_add,
			narratives_to_remove,
		},
	});

	return response;
};

/**
 *
 * @param {Object} args
 
 * @param {string} args.policy_id
 * @param {string} args.policy_start_date
 * @param {string} args.policy_end_date
 * @param {string} args.risk_id
 * @param {string} args.registration_number
 * @param {boolean} args.is_do_not_prorate
 * @returns
 */
export const notingRegistrationNumber = async ({
	policy_id,
	policy_start_date,
	policy_end_date,
	risk_id,
	registration_number,
	is_do_not_prorate,
}) => {
	let endpoint = "/policyModification";

	let response = await checkKey({
		endpoint,

		payload: {
			authorize_transaction: true,
			policy_id,
			effective_date: policy_start_date,
			end_date: policy_end_date,
			is_do_not_prorate: (is_do_not_prorate === null || is_do_not_prorate === undefined) ? false : is_do_not_prorate,
			action: "noting_registration_number",
			trans_wordings: {
				trans_wording: "Noting Registration No.  U.",
			},
			transaction_premium: 0,
			parameters: {
				risk_id,
				registration_number,
			},
			external_reference_number: "",
			is_tax_exempt: false,
			service_charge_type: "",
			service_charge_value: 0,
		},
	});

	return response;
};
/**
 *
 * @param {object} args
 
 * @param {string} args.national_id
 * @param {string} args.national_id_type
 * @returns
 */
export const getPoliciesByInsuredID = async ({ national_id, national_id_type }) => {
	let endpoint = "/getPoliciesByInsuredID";
	const reqType = "get";
	let response = await checkKey({
		endpoint,
		payload: {
			params: { national_id, national_id_type, active_only: true },
		},

		reqType,
	});
	return response;
};

export const setToCancel = async ({ policy_id, effective_date, is_manual_premium, reason, transaction_premium }) => {
	let endpoint = "/setToCancel";

	let response = await checkKey({
		endpoint,

		payload: {
			policy_id,
			effective_date,
			is_manual_premium,
			reason,
			transaction_premium,
		},
	});

	return response;
};

export const cancelPolicy = async ({
	policy_id,
	effective_date,
	authorize_transaction,
	trans_wording,
	is_manual_premium,
	reason,
	external_reference_number,
	transaction_premium,
}) => {
	let endpoint = "/cancelPolicy";

	let response = await checkKey({
		endpoint,

		payload: {
			policy_id,
			effective_date,
			is_manual_premium,
			reason,
			transaction_premium,
			authorize_transaction,
			trans_wording,
			external_reference_number,
		},
	});

	return response;
};

export const estimateValue = async (estimated_val) => {
	let payload = { estimated_val };
	let endpoint = "/estimateValue";
	let response = {};
	return response;
}

export const validateRegNo = async (registration_number, chassisNo, both=true) => {
	let payload = { registration_number, chassisNo, both };
	let response = {};
	const endpoint = `/misc/validate/regno`;

	response = await checkExpToken({ endpoint, payload });
	return response;
};

export const validateDriversLicence = async (trn) => {
	let payload = { trn };
	const endpoint = `/misc/validate/driverslicence`;
	let response = {};
	response = await checkExpToken({ endpoint, payload });
	return response;
};


export async function getAllRates() {
	const endpoint = "/quotes/get-all-rates";
	let response = {};
	const reqType = "get";
		response = await checkExpToken({endpoint, reqType});
			return response;
}
